import { createContext, useContext } from 'react'

import TailwindTheme from '../tailwind.config'

export type AppContextProps = {
  /** Ditto theme. */
  tailwind: typeof TailwindTheme
  /** Auth0 JWT token for the user. */
  jwtToken: () => Promise<string>
  /** True if the current user is a super admin */
  isSuperAdmin?: boolean
}

/** App context. */
const AppContext = createContext<AppContextProps>({
  tailwind: null,
  jwtToken: () => Promise.resolve(''),
  isSuperAdmin: false,
})

export const useAppContext = () => useContext(AppContext)

export default AppContext
